import { H3 } from 'foundations-components/transitional/components/H3';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getMetadataLanguageFallback } from '../achievementQueries';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { View } from 'foundations-components/transitional/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { List } from 'foundations-components/transitional/components/List';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CurriculumInfo = ({
  language,
  lessons,
  showStackedView
}) => {
  const {
    isLaptop
  } = useMediaQuery();
  if (!lessons) return null;
  const getMarginInlineStart = () => {
    if (showStackedView) return '0';
    if (isLaptop) return '0';
    return '1200';
  };
  return /*#__PURE__*/_jsx(View, {
    marginInlineStart: getMarginInlineStart(),
    paddingBlockStart: "1000",
    children: /*#__PURE__*/_jsx(Flex, {
      gap: "400",
      children: /*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsx(View, {
          children: /*#__PURE__*/_jsx(H3, {
            textAlign: showStackedView ? 'center' : 'left',
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.certification.curriculumCompleted"
            })
          })
        }), /*#__PURE__*/_jsx(View, {
          maxInlineSize: "600px",
          minBlockSize: "200px",
          children: /*#__PURE__*/_jsx(List, {
            children: lessons && lessons.map((lesson, i) => {
              const lessonName = getMetadataLanguageFallback(lesson.metadata, language).name;
              return /*#__PURE__*/_jsx(View, {
                as: "li",
                inlineSize: "fit-content",
                paddingBlock: "200",
                children: /*#__PURE__*/_jsxs(Flex, {
                  alignItems: "center",
                  gap: "400",
                  children: [/*#__PURE__*/_jsx(Box, {
                    flexShrink: 0,
                    children: /*#__PURE__*/_jsx(SuccessIcon, {
                      color: "icon-tertiary-default",
                      size: "400"
                    })
                  }), isLaptop ? lessonName : /*#__PURE__*/_jsx(TruncateString, {
                    useFlex: true,
                    children: lessonName
                  })]
                })
              }, i);
            })
          })
        })]
      })
    })
  });
};
export default CurriculumInfo;